import { gql } from '@apollo/client';

export const CREATE_CASE = gql`
  mutation CreateCase($input: CreateCaseInput!) {
    createCase(input: $input) {
      id
      name
    }
  }
`;
